/** Runtime array of CodeType values - use with getStringUnionMetadata() */
export const CODE_TYPE_VALUES = ['SERVICE', 'INVENTORY', 'NON-INVENTORY', 'KIT', 'BUNDLE', 'LABOUR', 'INCENTIVE', 'SOR'] as const;

export type CodeType = (typeof CODE_TYPE_VALUES)[number];

/**
 * For PICKERS AND SEARCH ONLY. Invoicing, billing, claiming, the recap and reporting treat a
 * SOR line like any other item. Apply this filter in a path they share and SOR items vanish
 * from the money side of the product.
 */
export const SOR_CODE_TYPES: CodeType[] = ['SOR'];

/** Whether a line is a SOR line. In-memory counterpart of `sorCodeTypeFilter`. */
export function isSorCode(code?: { type?: CodeType }): boolean {

    return !!code?.type && SOR_CODE_TYPES.includes(code.type);
}

/**
 * Three states because the boolean this replaced could only express two, leaving the third as an
 * implicit default buried in an else branch. That is how a rule written for pickers also hid SOR
 * from the catalogue manager, where a type nobody can list is a type nobody can edit.
 */
export enum SorCodeScope {

    /** Default when a request says nothing: SOR must not leak into an ordinary list. */
    Exclude = 'Exclude',

    /** A SOR-specific picker. */
    Only = 'Only',

    /** Management surfaces that have to show every type. */
    Include = 'Include',
}

/**
 * Whether an item generates an item task. SOR always does; every other type keeps the
 * catalogue flag. Truthy, not `=== true`, so non-SOR matches the raw checks this replaced.
 */
export function shouldAutoCreateTask(code?: { type?: CodeType, autoCreateTask?: boolean }): boolean {

    return isSorCode(code) || !!code?.autoCreateTask;
}

/**
 * Items-board view variants. When a mount passes `header.variant`, only system views with that
 * variant resolve; mounts with no variant only see views without a variant (Items Authorised / Pending).
 */
export enum JobItemViewVariant {
  SOR = 'SOR',
}
